export default class AbsoluteHeightCalculator {
  /**
   * Calculates the absolute width and height of an element and all its children
   * @param {HTMLElement} rootElement
   */
  constructor(rootElement) {
    if (!rootElement) throw new Error("No 'rootElement' was given")

    this.rootElement = rootElement
  }

  /**
   * Calculates the absolute width and height of the element
   * @returns {object} The calculated width and height of the element and all its children
   */
  calculate() {
    let maxWidth = 0
    let maxHeight = 0
    const rootRect = this.rootElement.getBoundingClientRect()

    for (const child of this.rootElement.querySelectorAll("*")) {
      const rect = child.getBoundingClientRect()
      const width = rect.right - rootRect.left
      const height = rect.bottom - rootRect.top

      if (width > maxWidth) maxWidth = width
      if (height > maxHeight) maxHeight = height
    }

    return {
      width: maxWidth,
      height: maxHeight
    }
  }

  /**
   *
   * @param {HTMLElement} element
   * @param {number} offsetLeft
   * @param {number} offsetTop
   * @returns {object} The calculated width and height of the element and all its children, relative to the root element's position.
   */
  calculateForElement(element, offsetLeft, offsetTop) {
    if (!element) throw new Error("No 'element' was given")

    const elementWidth = element.offsetWidth
    const elementHeight = element.offsetHeight

    const elementLeftRaw = getComputedStyle(element)["left"]
    const elementLeftPixelsMatch = elementLeftRaw.match(/^((|-)[\d.]+)px$/)

    const elementTopRaw = getComputedStyle(element)["top"]
    const elementTopPixelsMatch = elementTopRaw.match(/^((|-)[\d.]+)px$/)

    let elementLeft, elementTop

    if (elementLeftPixelsMatch) {
      elementLeft = Number(elementLeftPixelsMatch[1])
    } else {
      elementLeft = element.offsetLeft || 0
    }

    if (elementTopPixelsMatch) {
      elementTop = Number(elementTopPixelsMatch[1])
    } else {
      elementTop = element.offsetTop || 0
    }

    let maxWidth = offsetLeft + elementWidth + elementLeft
    let maxHeight = offsetTop + elementHeight + elementTop

    for (const child of element.children) {
      if (!child) throw new Error("Empty 'child' in 'children' array?")

      const {width: descendantsMaximumWidth, height: descendantsMaximumHeight} = this.calculateForElement(
        child,
        offsetLeft + elementLeft,
        offsetTop + elementTop
      )

      if (descendantsMaximumWidth > maxWidth) maxWidth = descendantsMaximumWidth
      if (descendantsMaximumHeight > maxHeight) maxHeight = descendantsMaximumHeight
    }

    return {
      width: maxWidth,
      height: maxHeight
    }
  }
}
